import { useForm } from "react-hook-form";

import { SelectControllerVertical } from "@components";
import { getConvertedPositionData } from "@helpers/baseDataConvert";
import { reports } from "@constants/yearly-reports-data";
import { useLanguage } from "@hooks/useLanguage";
import { Button, Text } from "@pentabd/ui";
import {
  IconArrowNarrowLeft,
  IconArrowNarrowRight,
  IconCalendar,
} from "@pentabd/icons";
import { useTranslation } from "react-i18next";

export const TableFilter = ({
  handleQuery,
  selectedData,
  year,
}: {
  handleQuery: (key: string, value: number | string) => void;
  selectedData: (id: number) => void;
  year: number;
}) => {
  const { t } = useTranslation();
  const { register, control, setValue } = useForm();
  const { language } = useLanguage();

  return (
    <div className="p-10 mb-10">
      <div className="row pb-0 mb-0">
        <SelectControllerVertical
          label="REPORTS.YEARLY_REPORTS.FILTERS.REPORT_TYPE"
          control={control}
          name="reports"
          register={register}
          cols={6}
          options={getConvertedPositionData(reports, language)}
          setValue={setValue}
          selectAction={(value) => {
            selectedData(value);
          }}
        />
        <div className="col-12 col-sm-6">
          <Text
            weight="semibold"
            color="title"
            size="sm"
            component="p"
            className="mb-3"
          >
            {t("REPORTS.YEARLY_REPORTS.FILTERS.YEAR.LABEL")}
          </Text>
          <div
            key="calendar"
            className="border border-primary-light px-10 py-5 d-flex rounded justify-content-between align-items-center"
          >
            <div className="d-flex">
              <Button
                className="p-0 border-none"
                size="sm"
                htmlType="button"
                fill="outline"
                type="light"
                disabled={year <= 1900 ? true : false}
              >
                <IconArrowNarrowLeft
                  size={20}
                  fill="subtitle2"
                  onClick={() => handleQuery("date", year - 1)}
                />
              </Button>
            </div>
            <div className="d-flex align-items-center">
              <Text className="pe-3 mt-2">{year}</Text>
              <IconCalendar size="17" fill="subtitle2" className="p-0 m-0" />
            </div>
            <div className="d-flex">
              <Button
                className="p-0 border-none"
                size="sm"
                htmlType="button"
                fill="outline"
                type="light"
                disabled={year >= new Date().getUTCFullYear()}
              >
                <IconArrowNarrowRight
                  size={20}
                  fill="subtitle2"
                  onClick={() => handleQuery("date", year + 1)}
                />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
